import { Injectable, Injector, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from '../components/snack-bar-error/snack-bar-error.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class SnackbarService {
    constructor() { }

    private _snackBarMessage = new BehaviorSubject<string>(null);
    snackBarMessage = this._snackBarMessage.asObservable();

    setSnackBarMessage(message) {
        this._snackBarMessage.next(message);
    }

    getSnackBarMessage() {
        return this._snackBarMessage;
    }
}